module.exports = __webpack_public_path__ + "static/media/CHAWCA_MENU-normal.910a7184.png";